import React from 'react'
import { object, string, bool } from 'prop-types'
import AirportParkingReviews from './airportParkingReviews.jsx'
import LocationReviewsDropDown  from './locationReviewsDropDown.jsx'
import SchemaTag from '../SchemaTag.jsx'

class LocationReviewRichSnippets extends React.Component {

  getDataFromFeed () {
    const { location } = this.props
    const productTypeReviews = this.getProductType() == 'parking' ? 'parkingReviewsMeta' : 'hotelReviewsMeta'
    const locationPath = location ? this.getFeedPath() + location.code : productTypeReviews
    try {
      const locationData = require('../../../../../config/exports/buildTimeOnly/reviews/' + locationPath + '.json')
      return locationData
    } catch (e) {
      return false
    }
  }

  getFeedPath () {
    const { pageData } = this.props
    switch (pageData.productClass.toUpperCase()) {
      case 'CP':
        return 'parking/meta/'
      case 'HCP':
        return 'hotels/meta/'
      case 'HO':
        return 'hotels/meta/'
      case 'LO':
        return 'lounges/meta/'
    }

    return ''
  }

  getProductType () {
    const { pageData } = this.props
    switch (pageData.productClass.toUpperCase()) {
      case 'CP':
        return 'parking'
      case 'HCP':
        return 'hotels'
      case 'HO':
        return 'hotels'
      case 'LO':
        return 'lounges'
    }

    return ''
  }

  renderFeedData (feedData, param) {
    let option = 'reviewsWithComments'
    if (param) {
      switch (param) {
        case 'percentage':
          return feedData.scoreAsPercentage + '%'
        case 'score':
          return Math.round(feedData.score) + '/10'
      }
    }
    return feedData[option]
  }

  pageExists (page) {
    try {
      const { pageData } = this.props
      const product = this.getProductType()
      const productUpper = product.charAt(0).toUpperCase() + product.slice(1)
      const reviewsPageData = require('../../../../../config/exports/buildTimeOnly/reviews/airport' + productUpper + 'ReviewsPages.json')
      if (reviewsPageData.indexOf(page) > -1 && !(pageData.pageName.indexOf('-reviews') > -1)) return page+'.html'
    } catch (e) {
      return false
    }
  }

  render () {
    const { id, location, pageData, noSchemaMarkup } = this.props
    const feedData = this.getDataFromFeed()
    const locationName = location ? location.name : 'Holiday Extras'
    const product = this.getProductType()
    const title = locationName ? locationName + ' airport ' + product + ' reviews' : 'Airport ' + product + ' reviews'
    const link = location ? location.pattern + '-airport-' + product + '-reviews' : 'airport-' + product + '-reviews'
    const reviewsLink = this.pageExists(link) ? this.pageExists(link) : false
    const reviewsPage = pageData.pageName.indexOf('-reviews') > -1
    const locRevDropDown = [ 'airport-parking-reviews', 'airport-hotels-reviews', 'airport-lounges-reviews', 'airport-lounges-reviews-test']

    return (

      <div id={id}>
        <SchemaTag tagType='p' noSchemaMarkup={noSchemaMarkup} itemProp='aggregateRating' itemScope itemType='http://schema.org/AggregateRating'>
          <span>Our customers rated </span>
          <span itemProp='itemreviewed'>{locationName} airport {product}</span>
          <span> on average </span>
          <SchemaTag tagType='span' noSchemaMarkup={noSchemaMarkup} itemProp='ratingValue' className='priceSmall'>{ feedData && this.renderFeedData(feedData, 'score') }</SchemaTag>
          <span> (</span>
          <SchemaTag tagType='span' noSchemaMarkup={noSchemaMarkup} itemProp='ratingCount' className='priceSmall'>
            { feedData && this.renderFeedData(feedData, 'reviews') }
          </SchemaTag>
          <span> reviews).</span>
          {reviewsLink &&
            <span> Read
              <a className='hover' href={reviewsLink} title={title}> {locationName} airport {product} reviews.</a>
            </span>
          }
          {locRevDropDown.indexOf( pageData.pageName ) > -1 &&
            <LocationReviewsDropDown id={id} pageData={pageData} />
          }
          {reviewsPage &&
            <AirportParkingReviews pageData={pageData} />
          }
        </SchemaTag>
      </div>
    )
  }
}

LocationReviewRichSnippets.propTypes = {
  id: string.isRequired,
  pageData: object.isRequired,
  location: object,
  noSchemaMarkup: bool
}

export default LocationReviewRichSnippets



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/locationReviewRichSnippets.jsx